import Vue from 'vue';
import Component from 'vue-class-component';

import ApprenticeDashboardView from './ApprenticeDashboardView/ApprenticeDashboardView.vue';
import CoachDashboardView from './CoachDashboardView/CoachDashboardView.vue';

/**
 * Handles which dashboard is shown to user
 */
@Component({
  name: 'DashboardHandler',
  components: {
    ApprenticeDashboardView,
    CoachDashboardView,
  },
})
export default class DashboardHandler extends Vue {
  get isCoach(): boolean {
    return this.$store.getters.isCoach;
  }

  get isApprentice(): boolean {
    return this.$store.getters.isApprentice;
  }
}
